import { WSElement, WSSectionToolbar } from "@wingspanhq/fe-component-library";
import {
  IPayerEngagementResponse,
  IPayerResponse
} from "@wingspanhq/payments/dist/interfaces";
import { wsName } from "@wingspanhq/utils/dist/name/wsName";
import { useMemo } from "react";
import { DataView } from "../../../shared/components/DataView";

type Props = {
  shimmer?: boolean;
  payer?: IPayerResponse;
  payerPayeeEngagement?: IPayerEngagementResponse;
};

export const WorkLogEngagementDetails: React.FC<Props> = props => {
  const engagementPreview = useMemo(() => {
    if (!props.payer) {
      return;
    }
    if (!props.payerPayeeEngagement) {
      return;
    }

    const names = wsName({
      user: {
        email: props.payer.user?.email as string,
        profile: props.payer.user?.profile
      },
      member: props.payer.member
    });

    return {
      name: names.getResolvedName(),
      company: names.companyName,
      email: names.email,
      engagementName: props.payerPayeeEngagement.engagementName
    };
  }, [props.payer, props.payerPayeeEngagement]);

  return (
    <WSElement>
      <WSSectionToolbar title="Engagement" />

      <DataView
        shimmer={props.shimmer}
        data={[
          {
            label: "Contact name",
            value: engagementPreview?.name
          },
          {
            label: "Client company",
            value: engagementPreview?.company
          },
          {
            label: "Contact email",
            value: engagementPreview?.email
          },
          {
            label: "Engagement",
            value: engagementPreview?.engagementName
          }
        ]}
      />
    </WSElement>
  );
};
